import { render } from "./ComisionDirectivaView.vue?vue&type=template&id=09082afc&scoped=true"
import script from "./ComisionDirectivaView.vue?vue&type=script&lang=js"
export * from "./ComisionDirectivaView.vue?vue&type=script&lang=js"

import "./ComisionDirectivaView.vue?vue&type=style&index=0&id=09082afc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09082afc"]])

export default __exports__